import {Table} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';
import {useFormatNumber} from 'platform/locale';

import {LEASING_ANNUAL_MILEAGES, LEASING_TERMS, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {LeasingMatrixRow} from './LeasingMatrixRow';
import {MatrixLegendItem} from './MatrixLegendItem';
import {LeasingCellCoordinates} from './types/LeasingCellCoordinates';

interface LeasingMatrixProps {
  vehicleLeasingBody: SaveSaleVehicleLeasingBody;
  currency: string;
  isReadOnly: boolean;
  onEditCell: (coordinates: LeasingCellCoordinates) => void;
}

export function LeasingMatrix(props: LeasingMatrixProps) {
  const formatNumber = useFormatNumber();

  return (
    <>
      <Box overflowX="auto">
        <Box width="100%" minWidth={202} maxWidth={268}>
          <Table
            variant="plain"
            tableLayout="fixed"
            columns={[
              {
                width: 20,
                element: (
                  <Text size="xSmall" color="secondary">
                    {i18n.t('page.vehicle.financingAndLeasing.term')}
                  </Text>
                ),
              },
              ...LEASING_ANNUAL_MILEAGES.map((annualMileage) => ({
                width: 26 as const,
                element: (
                  <Text size="xSmall" color="secondary">
                    {i18n.t('page.vehicle.financingAndLeasing.mileagePerYear', {
                      mileage: formatNumber(annualMileage),
                    })}
                  </Text>
                ),
              })),
            ]}
          >
            {LEASING_TERMS.map((term) => (
              <LeasingMatrixRow
                key={term}
                vehicleLeasingBody={props.vehicleLeasingBody}
                term={term}
                isReadOnly={props.isReadOnly}
                onEditCell={props.onEditCell}
              />
            ))}
          </Table>
        </Box>
      </Box>
      <HStack spacing={2} wrap>
        <MatrixLegendItem
          label={i18n.t('page.vehicle.financingAndLeasing.activePrimary')}
          backgroundColor="palettes.yellow.20.100"
        />
        <MatrixLegendItem
          label={i18n.t('page.vehicle.financingAndLeasing.configured')}
          backgroundColor="palettes.blue.20.100"
        />
        <MatrixLegendItem
          label={i18n.t('page.vehicle.financingAndLeasing.emptyClickToCreate')}
          backgroundColor="palettes.neutral.20.100"
        />
      </HStack>
    </>
  );
}
